import { GameStateEnums } from '../../../../shared/GameEnums.ts';
const UIGameEventEnums = GameStateEnums.UIGameEventEnums;
import { KeyBindController, ShortcutLocation } from '../KeyBindController.ts';
export class UIGamePauseController {
    createKeyBind() {
        KeyBindController.bindKey('KeyP', ()=>this.onAutoPauseTriggered(), ()=>this.keyBindListener(), ShortcutLocation.InGame);
    }
    keyBindListener() {
        if (this.state.paused) return false;
        return true;
    }
    togglePause(state) {
        this.state.remainingPauseTime = state.remainingPauseTime;
        this.state.paused = state.paused;
        this.uiGameManager.eventController.sendEvent(this.state.paused, UIGameEventEnums.GamePauseToggled);
    }
    isPaused() {
        return this.state.paused;
    }
    onAutoPauseTriggered() {
        if (this.state.paused) return;
        this.uiGameManager.socketGameSend.submitChat('/pause');
    }
    pauseIfSinglePlayer() {
        if (this.uiGameManager.gameController.isReplay) return;
        if (this.state.paused) return;
        if (!this.uiGameManager.gameState.hasOnlyOneHumanPlayer()) return;
        this.uiGameManager.socketGameSend.togglePause();
    }
    constructor(uiGameManager){
        this.state = {
            paused: false
        };
        this.uiGameManager = uiGameManager;
        this.createKeyBind();
    }
}
